import * as Yup from 'yup'
import {getLanguage} from 'react-multi-lang'
import { msgs } from '../../services/Validation/msgs'


export const BillValidation =  Yup.object().shape({
      note: Yup.string().notRequired(),
      total: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      discount_percentage: Yup.number()
     
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      discount_amount: Yup.number()
       
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      discount_value: Yup.number()
        .when('total',([total],schema)=>{
          if (total) {
            let max_threshold = parseFloat((total * 0.05).toFixed(2))
            return schema.max(max_threshold,msgs.max_msg(max_threshold))
          }
            return schema
        }
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      total_net: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      tax_amount: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      net_after_tax: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      net_after_tax_str: Yup.string()
        .min(
          1,
          getLanguage() === 'en'
            ? "This field can't be less than 1 char"
            : 'هذا الحقل لا يمكن أن يكون أقل من حرف واحد',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      paid: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ).when('net_after_tax',([net_after_tax],schema)=>{
          if (net_after_tax){
            let max_threshold = parseInt(net_after_tax)
            return schema.max(max_threshold,msgs.max_msg(max_threshold))
          }
          return schema
        })

        
        ,
      remains: Yup.number()
        .min(
          0,
          getLanguage() === 'en'
            ? "This field can't be less than 0"
            : 'هذا الحقل لا يمكن أن يكون أقل من 0',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
      seller_name: Yup.string()
        .min(
          1,
          getLanguage() === 'en'
            ? "This field can't be less than 1 char"
            : 'هذا الحقل لا يمكن أن يكون أقل من حرف واحد',
        )
        .required(
          getLanguage() === 'en' ? 'This field is required' : 'هذا الحقل مطلوب',
        ),
    })